// utils
import {
    checkFavoriteList,
    createElement,
    error,
    jsDots,
    jsLink,
    safeJSONParse,
    updateHotelViewObserver
} from 'methods/utils';
import {ajaxGetData} from 'methods/ajaxData';
import Faq from '/modules/kurort/src/js/components/faq';
import initGeneralOptionIcons from './components/init-general-option-icons';

// common components
import SimpleBar from 'simplebar';
import Modal from 'developer_components/newModal';
import ModalDialog from 'components/modal-dialog.dev';
import ShareModal from 'components/share-modal';
import Swiper from 'swiper';
import ListViewedHotels from 'components/list-viewed-hotels';
import {Navigation, Pagination} from 'swiper/modules';

// page components
import ApartmentPrices from './components/apartment-prices';
import HotelMap from './components/hotel-map';
import HotelRecalls from './components/hotel-recalls';
import HotelMetrika from './components/hotel-metrika';
import metrikaCollector, {collectMailruReachGoal, collectYandexReachGoal} from 'components/metrika';
import HotelMenuNavigation from './components/hotel-menu-navigation';
import Hint from 'components/hint';
import Header from 'components/header';
import HotelPhotogallery from './components/hotel-photogallery';
import ApartmentPhotogallery from './components/apartment-photogallery';
import UnverifiedPlate from './components/unverified-plate';
import HotelOptionsModal from './components/modals/hotel-options-modal';
import HotelMapModal from './components/modals/hotel-map-modal';
import ApartmentModal from './components/modals/apartment-modal';
import Feedback from '/modules/feedback/src/js/feedback';
import {initSidePhonesMetrika} from './components/side-phones-metrika';

initSidePhonesMetrika();

function Page() {
    this.hotelData = {...document.querySelector('.js-hotelData').dataset};

    // swiper промоакций
    this._initPromo = function() {
        let $promoList = document.querySelector('.js-promoList');
        if (!$promoList) {
            return;
        }

        if ($promoList.querySelectorAll('.item').length === 1) {
            return;
        }

        new Swiper($promoList, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            loop: true,
            pagination: {
                el: $promoList.querySelector('.swiper-pagination'),
            },
        });
    }

    this._initViewsList = function() {
        const hotelId = Number(this.hotelData.hotel_id);
        const views = new ListViewedHotels();

        views.append(hotelId);
    }

    // клик показать общий прайс
    this._initPrice = function() {
        const $showPrice    = document.querySelector('.js-showPrice');
        const $calendarData = document.querySelector('.js-calendarData');
        if ($showPrice) {
            $showPrice.addEventListener('click', (e) => $calendarData.classList.toggle('is-active'));
        }

        const $priceTabButtons = document.querySelectorAll('.js-priceTabButton');
        const $priceTables = document.querySelectorAll('.js-priceTable');

        // прокидываем ширину sticky элементам
        const updateFlexColumnWidth = function updateFlexColumnWidth($table) {
            let $tr_prev;
            let $tr_sticky_prev;

            $table.querySelectorAll('tr').forEach($tr => {
                let $sticky_prev;

                $tr.querySelectorAll('.sticky').forEach($sticky => {
                    let width   = $sticky.offsetWidth;
                    let rowspan = $sticky.getAttribute('rowspan');

                    $sticky.style.width    = width + 'px';
                    $sticky.style.minWidth = width + 'px';
                    $sticky.style.maxWidth = width + 'px';

                    if ($sticky_prev) {
                        $sticky.style.left = $sticky_prev.offsetWidth + 'px';
                    } else {
                        $sticky.style.left = '0px';
                    }

                    $sticky_prev = $sticky;

                    if (rowspan) {
                        $tr_prev        = $tr;
                        $tr_sticky_prev = $sticky_prev;
                    }

                    if ($tr_prev && $tr_prev !== $tr) {
                        $tr_prev = null;

                        $sticky.style.left = $tr_sticky_prev.offsetWidth + 'px';
                    }
                });
            });
        }

        const calcPriceScrollbar = function calcPriceScrollbar() {
            const $content = document.querySelector('.js-calendarData > .content');
            if ($content) {
                $content.classList.remove('has-scrollbar');
            }

            $priceTables.forEach($table => {
                if ($table.offsetWidth > $table.parentNode.offsetWidth) {
                    $table.parentNode.classList.add('has-scrollbar');

                    updateFlexColumnWidth($table);
                }
            });
        }
        calcPriceScrollbar();

        $priceTabButtons.forEach(($item, i) => $item.addEventListener('click', (e) => {
            $priceTables.forEach($table => $table.classList.remove('is-active'));
            $priceTabButtons.forEach($tab => $tab.classList.remove('is-active'));

            $priceTabButtons[i].classList.add('is-active');
            $priceTables[i].classList.add('is-active');

            calcPriceScrollbar();
        }));
    }

    // подгружаем другие объекты
    this._otherHotel = function() {
        let $otherHotelBlock = document.querySelector('.js-otherHotels');
        if (!$otherHotelBlock) {
            return;
        }

        let $swiper = $otherHotelBlock.querySelector('.Selections__wrapper > .Selections__list');
        new Swiper($swiper, {
            slidesPerView: 4,
            spaceBetween: 20,
            speed: 300,
            loop: true,
            navigation: {
                prevEl: document.querySelector('.js-otherHotels .Selections__prev'),
                nextEl: document.querySelector('.js-otherHotels .Selections__next'),
            },
        });

        // Опции карточки объекта
        jsDots();

        // показы объектов
        updateHotelViewObserver();

        // отмечаем избранное
        checkFavoriteList();
    }

    this._initPhoneHint = function() {
        // показать/скрыть подсказку по номеру телефона
        function showNoContacts($button) {
            const $contactNotification = $button.parentNode.querySelector('.js-contactNotification');
            const buttonToggle         = $button.classList.toggle('is-active');

            // показываем подсказку
            $contactNotification.classList.toggle('is-hidden', !buttonToggle);
        }

        // общий обработчик кликов
        document.addEventListener('click', function(e) {
            const $item = e.target;

            // клик по кнопке карты
            if ($item.classList.contains('js-showNoContacts')) {
                return showNoContacts($item);
            }
        });
    }

    this._initModals = function() {
        // сертификат соотв
        let $openImageModal = document.querySelector('.js-openImageModal');
        if ($openImageModal) {
            $openImageModal.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                new ModalDialog({
                    containerClass: 'Hotel-image-modal-wrapper',
                    header: 'Сертификат соответствия',
                    descriptionHTML: `<img src="${e.target.dataset.originalSrc}" />`,
                });
            });
        }
    }

    this._initApartments = function() {
        this._apartmentPrices = new ApartmentPrices();

        // для тегов убираем точки для элементов на новой строчке
        // точки для опций номеров с 1 раза не работают поэтому несколько раз
        let clearDots = (count = 0) => {
            if (count > 3) {
                return false;
            }

            document.querySelectorAll('.js-tagList, .js-subtitleList').forEach($container => {
                let offsetTop = 0;

                $container.querySelectorAll('.item').forEach($item => {
                    $item.classList.remove('new-row');

                    if (offsetTop == 0) {
                        offsetTop = $item.offsetTop;
                    }

                    if (offsetTop < $item.offsetTop) {
                        offsetTop = $item.offsetTop;
                        $item.classList.add('new-row');
                    }
                });
            });

            count++

            setTimeout(() => clearDots(count), 1500);
        }
        clearDots();

        // фотогалерея номера + swiper
        new ApartmentPhotogallery();

        // модалка "Подробное описание"
        document.querySelectorAll('.js-apartmentItem').forEach(($apartment, index) => {
            const $data = $apartment.querySelector('.js-data');
            const data  = safeJSONParse($data.innerHTML, {});
            const $more = $apartment.querySelector('.js-showMoreApartment');

            if ($more) {
                $more.addEventListener('click', e => {
                    if (!$apartment.__modal) {
                        $apartment.__modal = ApartmentModal.make(data, {
                            // options
                        });
                    }

                    $apartment.__modal.open();
                });
            }

        });
    }

    this._initVideoBlock = function() {
        // кнопка просмотра iFrame
        document.querySelectorAll('.js-iframeButton[data-iframe]').forEach($button => $button.addEventListener('click', (e) => {
            $button.classList.add('init');
            $button.innerHTML = `<iframe src="${$button.dataset.iframe}" style="width: ${$button.offsetWidth}px; height: ${$button.offsetHeight}px; border-radius: 20px;" frameborder="0" allowfullscreen="" style=""></iframe>`;
        }));
    }

    this._initShare = function(args = {}) {
        // клик по кнопке поделится
        let $shareOpen = document.querySelector('.js-shareOpen');

        if (args && args.$shareOpen) {
            $shareOpen = args.$shareOpen;
        }

        if (!$shareOpen) {
            return;
        }

        new ShareModal($shareOpen);
    }

    this._showDialog = function() {
        // показываем сообщения из сессии
        new ModalDialog({getSession: true})
    }

    this._showMoreDescription = function () {
        const $moreButton = document.querySelector('.js-showMoreDescription');
        if (!$moreButton) {
            return;
        }

        const $descriptionContainer = document.querySelector('.js-descriptionContainer');
        const initialHeight = $descriptionContainer.offsetHeight;
        let isOpen = false;

        if ($descriptionContainer.offsetHeight === $descriptionContainer.scrollHeight) {
            $descriptionContainer.style.height = 'auto';
            $moreButton.style.display = 'none';
        } else {
            const $paragraph = $descriptionContainer.querySelector('p');

            if ($paragraph) {
                $descriptionContainer.style.height = `${Math.min($descriptionContainer.offsetHeight, $paragraph.offsetHeight)}px`;
            }
        }

        $moreButton.addEventListener('click', () => {
            $descriptionContainer.style.height = 'auto';

            isOpen = !isOpen;
            $descriptionContainer.style.height = isOpen ? 'auto' : `${initialHeight}px`;
            $moreButton.innerHTML = isOpen ? 'Скрыть' : 'Показать еще';
        });
    }

    this._initMetrika = function() {
        new HotelMetrika();
    }

    this._initHotelMenu = function() {
        this._navigationMenu = new HotelMenuNavigation();
    }

    this._initYoutubeSlider = function () {
        const $container = document.querySelector('.js-youtubeSliderContainer');

        if ($container) {
            const $swiper = $container.querySelector('.js-youtubeSlider');

            $swiper.querySelectorAll('.Youtube__item').forEach($item => {
                const width = $item.getAttribute('data-width');
                if (width) {
                    $item.style.setProperty('width', `${width}px`);
                    $item.style.setProperty('max-width', `${width}px`);
                }

                const height = $item.getAttribute('data-height');
                if (height) {
                    $item.style.setProperty('height', `${height}px`);
                }
            });

            new Swiper($swiper, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                navigation: {
                    prevEl: $container.querySelector('.js-youtubeSliderPrev'),
                    nextEl: $container.querySelector('.js-youtubeSliderNext'),
                },
            });
        }
    }

    this._initHotelMap = function() {
        this._map = new HotelMap();
        this._$mapClosestHotels = document.querySelector('.js-mapClosestHotels');

        if (this._$mapClosestHotels) {
            this._$mapClosestHotels.addEventListener('change', () => {
                if (typeof yaCounter46243086 != 'undefined') {
                    yaCounter46243086.reachGoal('best_deal_on_map');
                    collectYandexReachGoal(metrikaCollector, 'best_deal_on_map');
                }
                this._updateMapHotelsVisible();
            });
            this._map.whenInitialized(this._updateMapHotelsVisible.bind(this));
        }
    }

    this._updateMapHotelsVisible = () => {
        this._map.setHotelsVisible(this._$mapClosestHotels.checked);
    }

    this._initHotelRecalls = function() {
        new HotelRecalls();
    }

    this._initFeedback = function() {
        new Feedback();
    }

    this._initHotelPhotogallery = function() {
        new HotelPhotogallery();
    }

    this._initHint = function() {
        document.querySelectorAll('[data-hint]:not(.initialized)').forEach($item => {
            $item.classList.add('initialized');

            new Hint($item, {
                content: $item.dataset.hint,
                placement: 'bottom',
                width: $item.dataset.width ? $item.dataset.width : null,
            });
        });
    }

    this._initHotelContacts = function() {
        let $buttons = document.querySelectorAll('.js-openContactModal');
        let $modal  = document.querySelector('#contact-modal');

        if ($buttons.length && $modal) {
            let modal = new Modal($modal);

            $buttons.forEach($button => $button.addEventListener('click', () => {
                modal.open();

                fetch('/metrika/call_button/' + this.hotelData.hotel_id + '/', {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }).then(response => response.text());

                // клик по кнопке "позвонить"
                if (typeof yaCounter46243086 !== "undefined") {
                    yaCounter46243086.reachGoal('call_button');
                    collectYandexReachGoal(metrikaCollector, 'call_button', {
                        data: {hotel_id: this.hotelData.hotel_id},
                    });
                }

                if (typeof _tmr !== 'undefined') {
                    _tmr.push({ type: 'reachGoal', id: 3512243, goal: 'show_contacts'});
                    collectMailruReachGoal(metrikaCollector, 'show_contacts');
                }
            }));
        }

    }

    this._initHotelOptionsModal = function () {
        const $button = document.querySelector('.js-openOptionsModal');
        if (!$button) {
            return;
        }

        const $data  = $button.querySelector('.js-openOptionsModalData');
        const groups = JSON.parse($data.innerHTML);
        const modal  = new HotelOptionsModal(groups);

        $button.addEventListener('click',  () => {
            modal.open();
        });
    }

    this._initOrders = function() {
        let $block = document.querySelector('#Message');
        if (!$block) {
            return;
        }

        let $swiper = $block.querySelector('.js-swiper');
        let $tabs   = $swiper.querySelectorAll('.js-tabItem');

        // табы
        new Swiper($swiper, {
            slidesPerView: 'auto',
            spaceBetween: 16,
        });

        // клик по табу
        $tabs.forEach($tab => $tab.addEventListener('click', () => {
            let $activeTab   = $block.querySelector('.js-tabItem.active');
            let $activeBlock = $block.querySelector('.js-orderBlock.active');

            $activeTab.classList.remove('active');
            $activeBlock.classList.remove('active');

            $tab.classList.add('active');
            $block.querySelector(`.js-orderBlock[data-id="${$tab.dataset.id}"]`).classList.add('active');
        }));

        // добавляем таб в меню
        this._navigationMenu.appendChild(createElement(`
            <li class="item">
                <button class="flex js-menuItem" data-href="#Message" data-index="${this._navigationMenu.menuItemCount + 1}">Мои заявки <span class="quantity">${$tabs.length}</span></button>
            </li>`
        ));

        // магия
        setTimeout(() => {
            this._navigationMenu._initNavMenu();
            this._navigationMenu._initLocationHash();
        }, 250);

        // отправка заявок
        $block.querySelectorAll('.js-orderBlock').forEach($orderBlock => {
            let $form = $orderBlock.querySelector('.js-messageForm');
            if (!$form) {
                return;
            }

            $form.addEventListener('submit', (e) => {
                e.preventDefault();
                e.stopPropagation();

                if ($form.classList.contains('loading')) {
                    return;
                }
                $form.classList.add('loading');

                fetch($form.getAttribute('action'), {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: new FormData($form),
                })
                .then(response => response.json())
                .then(r => {
                    $form.classList.remove('loading');
                    if (r.status === 'error') {
                        new ModalDialog({
                            header: 'Ошибка',
                            message: r.message,
                            useSuccessButton: true,
                        });
                    } else {
                        new ModalDialog({
                            header: 'Ваше сообщение отправлено',
                            message: 'Ожидайте ответа. Спасибо :)',
                            useSuccessButton: true,
                        });

                        if (r.block) {
                            $orderBlock.querySelector('.js-messageList').appendChild(createElement(r.block));

                            $form.querySelector('.js-textField').value = '';
                        }
                    }
                });
            });
        });
    }

    this._initBlocks = function(blocks) {
        for (let alias in blocks) {
            switch(alias) {
                case 'message':
                    let $messageBlock = document.querySelector('.js-messageBlock');
                    if (!$messageBlock) {
                        break;
                    }

                    let $div = document.createElement('div');

                    $messageBlock.parentNode.insertBefore($div, $messageBlock.nextSibling);

                    $div.outerHTML = blocks[alias];
                    $messageBlock.remove();

                    this._initOrders();
                    break;
                case 'other_hotel':
                    let $otherHotelBlock = document.querySelector('.js-otherHotels');
                    $otherHotelBlock.innerHTML = blocks[alias];

                    this._otherHotel();
                    break;
                case 'side_phones':
                    let $sidePhonesList = document.querySelector('.js-sidePhonesList');
                    if ($sidePhonesList && blocks[alias]) {
                        $sidePhonesList.innerHTML = blocks[alias];
                    }
                    break;
                case 'side_phones_max':
                    let $sidePhonesMax = document.querySelector('.js-sidePhonesMax');
                    if ($sidePhonesMax) {
                        $sidePhonesMax.innerHTML = blocks[alias] || '';
                    }
                    break;
            }
        }
    }

    this._initHeader = function() {
        this._header = new Header(document.querySelector('.js-header'), {
            on: {
                'search:submit': (data) => {
                    if (data.redirect || !this._apartmentPrices.isInit) {
                        return;
                    }

                    if (this._apartmentPrices.setSearchData) {
                        this._apartmentPrices.setSearchData(this._header.getSearchData());
                    }

                    if (this._apartmentPrices.recalc) {
                        this._apartmentPrices.recalc();
                    }
                },
            },
        });

        // обновление верхнего поиска при обновлении данных в калькуляторе цен
        this._apartmentPrices.on('search:change', data => {
            this._header.setSearchData(data);
        });
    }

    this._initPlaces = function () {
        this.$places = document.querySelector('.js-places');
        if (!this.$places) {
            return;
        }

        this.placesSwiper = new Swiper(this.$places.querySelector('.Selections__wrapper > .Selections__list'), {
            slidesPerView: 4,
            spaceBetween: 20,
            speed: 300,
            loop: false,
            navigation: {
                prevEl: this.$places.querySelector('.js-swiperArrowPrev'),
                nextEl: this.$places.querySelector('.js-swiperArrowNext'),
            },
        });
    }

    /**
     * Все необходимые данные для страницы
     */
    this._loadData = function() {
        ajaxGetData().then((r) => {
            // модалки
            if (r.modals && r.modals.length > 0) {
                let $div = document.createElement('div');
                    $div.innerHTML = r.modals;
                document.body.appendChild($div);
            }

            // блоки
            if (r.blocks) {
                this._initBlocks(r.blocks);
            }

            [
                this._initHotelPhotogallery,
                this._initHotelRecalls,
                this._initHotelContacts,
                this._initHeader,
            ].forEach(fn => {
                try {
                    fn.bind(this)();
                } catch(e) {
                    error(e);
                }
            });
        });
    }

    this._initUnverifiedPlate = function() {
        const $plate = document.querySelector('.js-unverifiedPlate');
        if (!$plate) {
            return;
        }

        new UnverifiedPlate($plate);
    }

    this._initHotelModalMap = function() {
        if (!document.querySelector('.js-show-on-map')) {
            return;
        }

        const modal = new HotelMapModal({
            map: this._map,
        });

        document.addEventListener('click', (event) => {
            const $target = event.target;

            if ($target.closest('.js-show-on-map')) {
                modal.open();
            }
        });
    }

    this._initFaqBlock = function() {
        const $faqBlock = document.querySelector('.js-faq');
        if (!$faqBlock) {
            return;
        }

        new Faq($faqBlock);
    }

    this._initGeneralOptionIcons = function() {
        initGeneralOptionIcons();
    }

    this.init = function() {
        Swiper.use([Navigation, Pagination]);
        window.jsLink = jsLink;

        [
            this._showDialog,
            this._showMoreDescription,
            this._initMetrika,
            this._initHotelMenu,
            this._initHotelMap,
            this._initPrice,
            this._initPromo,
            this._initViewsList,
            this._initPhoneHint,
            this._initModals,
            this._initApartments,
            this._initShare,
            this._initVideoBlock,
            this._loadData,
            this._initFeedback,
            this._initHint,
            this._initUnverifiedPlate,
            this._initYoutubeSlider,
            this._initHotelOptionsModal,
            this._initHotelModalMap,
            this._initFaqBlock,
            this._initGeneralOptionIcons,
            this._initPlaces,
            () => {
                let $review = document.getElementById('Review');
                if (location.hash === '#add_recall' && $review) {
                    setTimeout(() => {
                        document.querySelectorAll('[data-href="#Review"]').forEach($button => $button.click());

                        document.querySelectorAll('.js-openRecallModal').forEach($button => {
                            setTimeout(() => {
                                $button.click();
                            }, 2000);
                        });
                    }, 250);
                }
            },
        ].forEach(fn => {
            try {
                fn.call(this);
            } catch(e) {
                error(e);
            }
        });
    }
    this.init();
}

window.page = new Page();
